export enum LocalStorageEnum {
  TOKEN = 'token',
  LANGUAGE = 'language',
  SINISTER_ID = 'sinisterId',
  SINISTER_ID_EC = 'sinId',
  USER_TYPE = 'userType',
  FLOW = 'flow',
  NEXT_STATE = 'nextState',
  STATE = 'state',
  FNOL = 'fnol',
  FNOL_START = 'fnolStart',
  MOBILIER = 'mobilier',
  SUMMARY_MOBILIER = 'summaryMobilier',
  FORM_ID = 'formId'
}
